import { countBy } from 'es-toolkit/compat';

import {
  getFileInfoSlideIntakeEvidence,
  getSlideIntakeLifecycle,
  SlideIntakeLifecycleState,
} from 'components/SlideIntake/lifecycle';
import { UploadListResponse } from 'interfaces/fileList';

export interface StudyIngestNotice {
  ingesting: number;
  queued: number;
  failed: number;
  rejected: number;
  /** Uploads with a usable ingest, whether or not they are assigned to a case yet. */
  ingested: number;
  /** Uploads whose ingest is running or waiting to run: organizing them now would be premature. */
  inProgress: number;
  /** Uploads with no usable ingest and nothing running that will produce one. */
  notIngested: number;
  /** True only when the response proves the study has no uploads at all; missing groups are inconclusive. */
  hasNoUploads: boolean;
}

export const getStudyIngestNotice = (uploadList?: UploadListResponse): StudyIngestNotice => {
  const pending = uploadList?.slides?.pending;
  const processed = uploadList?.slides?.processed;
  const slideRows = [...(pending ?? []), ...(processed ?? [])];
  const stateCounts = countBy(
    slideRows,
    (row): SlideIntakeLifecycleState => getSlideIntakeLifecycle(getFileInfoSlideIntakeEvidence(row)).state
  );
  const ingesting = stateCounts.ingesting ?? 0;
  const queued = stateCounts.queuedForIngest ?? 0;
  const failed = stateCounts.ingestFailed ?? 0;
  const rejected = stateCounts.rejectedIngest ?? 0;

  return {
    ingesting,
    queued,
    failed,
    rejected,
    ingested: (stateCounts.needsCaseAssignment ?? 0) + (stateCounts.assignedToCase ?? 0),
    inProgress: ingesting + queued,
    notIngested: failed + rejected,
    hasNoUploads:
      Array.isArray(pending) && Array.isArray(processed) && Array.isArray(uploadList?.all)
        ? slideRows.length === 0 && uploadList.all.length === 0
        : false,
  };
};
